import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const scrollToTop = () => {
  if ('scrollBehavior' in document.documentElement.style) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  } else {
    window.scrollTo(0, 0);
  }
};

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Canadian Biobank </h3>
            <p>
              A groundbreaking research study focused on understanding health outcomes 
              in young adults aged 18-29. Join us in advancing medical research and 
              improving healthcare for future generations.
            </p>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <Link to="/about" onClick={scrollToTop}>About the Study</Link>
              <Link to="/team" onClick={scrollToTop}>Research Team</Link>
              <Link to="/participate" onClick={scrollToTop}>How to Participate</Link>
            </div>
          </div>

          <div className="footer-section">
            <h3>Study Information</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <p>Age Range: 18-29 years</p>
              <p>Target Participants: 20,000</p>
              <p>Study Sites: 5 locations</p>
              <p>Duration: 15 years follow-up</p>
            </div>
          </div>

          <div className="footer-section">
            <h3>Contact</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <Mail size={16} />
                <span>info@canadianbiobank.ca</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <Phone size={16} />
                <span>1-800-CBP-HELP</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <MapPin size={16} />
                <span>Waterloo, Ontario, Canada</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>
              © 2025 Canadian Biobank. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
